import { createContext } from 'react';

const SourcesContext = createContext({});
export default SourcesContext;
